import { SVG } from "../../AbstractElements";
import { useAppDispatch, useAppSelector } from "../../Redux-Toolkit/Hooks";
import { setMixBackgroundLayout } from "../../Redux-Toolkit/Reducers/ThemeCustomizerSlice";

export const DarkButton = () => {
  const{mix_background_layout} = useAppSelector((state) => state.themeCustomizer)
  const dispatch = useAppDispatch();
  const handleDarkMode = (name:string) => {
    if (name === "light-only") {
      document.body.classList.remove("light-only");
      document.body.classList.add("dark-only");
      dispatch(setMixBackgroundLayout("dark-only"));
    } else if(name === "dark-only"){
      document.body.classList.remove("dark-only");
      document.body.classList.add("light-only");
      dispatch(setMixBackgroundLayout("light-only"));
      }
  }

  return (
    <div className={`mode ${mix_background_layout === "dark-only" ? "active" : ""}`}>
      <SVG iconId="moon" onClick={()=>handleDarkMode(mix_background_layout)} />
    </div>
  );
};
